import { eventChannel, END } from 'redux-saga'

export const createUploadFileChannel = (endpoint, file) =>
  eventChannel((emitter) => {
    const { type } = file
    const xhr = new XMLHttpRequest()
    const onProgress = (e) => {
      if (e.lengthComputable) {
        const progress = parseInt((e.loaded / e.total) * 100, 10)
        emitter({ progress })
      }
    }
    const onFailure = () => {
      emitter({ error: new Error('Upload failed') })
      emitter(END)
    }
    xhr.upload.addEventListener('progress', onProgress)
    xhr.upload.addEventListener('error', onFailure)
    xhr.upload.addEventListener('abort', onFailure)
    xhr.onreadystatechange = () => {
      const { readyState, status } = xhr
      if (readyState === 4) {
        if (status === 200) {
          emitter({ success: true })
          emitter(END)
        } else {
          onFailure(null)
        }
      }
    }
    xhr.open('PUT', endpoint, true)
    xhr.setRequestHeader('Content-Type', type)
    xhr.setRequestHeader('x-amz-acl', 'bucket-owner-full-control')
    xhr.setRequestHeader(
      'x-amz-meta-environment',
      process.env.NODE_ENV === 'production' ? 'retriever' : 'staging-retriever',
    )
    xhr.send(file)
    return () => {
      xhr.upload.removeEventListener('progress', onProgress)
      xhr.upload.removeEventListener('error', onFailure)
      xhr.upload.removeEventListener('abort', onFailure)
      xhr.onreadystatechange = null
      xhr.abort()
    }
  })
